import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Row, Col } from "react-bootstrap";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);
const DistricTrends = (props) => {
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const [DPTrends, SetDPTrends] = useState();
  const [SPTrends, SetSPTrends] = useState();
  const [SelectDistrict, SetSelectDistrict] = useState(
    props.DistrictIds?.[0]?.value
  );
  const DistrictPerformanceTrends = async (District) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/InstitutionAdmin/GetDistrictPerformanceTrendsByInstitute?Year=${USYear?.value}&AssessmentType=${props.AType}&InstituteId=${items?.instituteId}&DistrictId=${District}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].assessmentDate) {
          SetDPTrends(res.data);
          SetSelectDistrict(District);
        } else {
          SetDPTrends(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const SocietyDistrictPerformanceTrends = async (District) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/InstitutionAdmin/GetSocietyDistrictPerformanceTrendsByInstitute?Year=${USYear?.value}&AssessmentType=${props.AType}&InstituteId=${items?.instituteId}&DistrictId=${District}&SocietyId=${items?.societyId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].assessmentDate) {
          SetDPTrends(res.data);
          SetSelectDistrict(District);
        } else {
          SetDPTrends(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (items?.societyId) {
      SocietyDistrictPerformanceTrends(
        props.SelecteDistrict?.DistrictId || SelectDistrict
      );
    } else {
      DistrictPerformanceTrends(
        props.SelecteDistrict?.DistrictId || SelectDistrict
      );
    }
  }, [SelectDistrict, props.AType, props.SelecteDistrict?.DistrictId, USYear]);
  const labels = [];
  const Subjects = {};

  if (DPTrends?.[0].assessmentDate) {
    DPTrends?.forEach((item) => {
      if (
        !labels.includes(item.assessmentDate) &&
        props.SubSelect === item.subjectName
      ) {
        labels.push(item.assessmentDate);
      }
      if (!Subjects[item.subjectName]) {
        Subjects[item.subjectName] = [];
      }
    });
    DPTrends?.forEach((item) => {
      Subjects[item.subjectName].push(item.percentage);
    });
  }

  const datasets = Object.keys(Subjects).map((Subject) => ({
    label: Subject,
    data: Subjects[props.SubSelect],
    backgroundColor:
      {
        English: "#7C60BC",
        Mathematics: "#00A2B9",
        Science: "#3DA663",
        Biology: "#F7C66A",
        BioTechnology: "#A63D95",
        "Physics and Chemistry": "#3B9ED7",
      }[(Subject, props.SubSelect)] || "#000",
    borderColor:
      {
        English: "#7C60BC",
        Mathematics: "#00A2B9",
        Science: "#3DA663",
        Biology: "#F7C66A",
        BioTechnology: "#A63D95",
        "Physics and Chemistry": "#3B9ED7",
      }[(Subject, props.SubSelect)] || "#000",
    maxBarThickness: 40,
    barThickness: 45,
  }));

  const data = { labels: labels, datasets: datasets };
  const options = {
    aspectRatio: 2,
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            if (context.dataset.label === props.SubSelect) {
              const label = context.dataset.label || "";
              const value =
                context.parsed.y !== null ? context.parsed.y + "%" : "";
              return `${label}: ${value}`;
            }
            return null;
          },
        },
      },
    },
    scales: {
      x: {
        offset: 20,
        grid: { display: false },
        title: { display: true, text: "Assessment Date" },
      },
      y: {
        title: { display: true, text: "Performance %" },
        beginAtZero: true,
        max: 100,
      },
    },
  };
  const ChangeDistrict = (e) => {
    SetSelectDistrict(e);
  };
  return (
    <>
      <div className="dflex JSBetween mb-2">
        <div className="SubHeading">
          Districtwise performance{" "}
          {props.SelecteDistrict && `- ${props.SelecteDistrict?.DistrictName}`}
        </div>
        {!props.SelecteDistrict && (
          <div>
            {props.DistrictIds && (
              <DropdownValues
                className="NCLDropdown"
                options={props.DistrictIds}
                onChange={(e) => ChangeDistrict(e.target.value)}
                selectoption={SelectDistrict}
              />
            )}
          </div>
        )}
      </div>
      {DPTrends?.[0].assessmentDate ? (
        labels.length !== 0 ? (
          <Line options={options} data={data} />
        ) : (
          <div className="ErrorMessage">
            {process.env.REACT_APP_NODATAFOUND_Participated}
          </div>
        )
      ) : (
        <div className="ErrorMessage">{DPTrends}</div>
      )}
    </>
  );
};
export default DistricTrends;
